import { render, staticRenderFns } from "./PressView.vue?vue&type=template&id=463a8b6d&"
import script from "./PressView.vue?vue&type=script&lang=js&"
export * from "./PressView.vue?vue&type=script&lang=js&"
import style0 from "./PressView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports